import type { PaletteOptions } from '@mui/material/styles'

import { SemanticTokens } from './semantic'

/**
 * Legacy palette keys re-expressed with semantic tokens. Keys left out keep their legacy value,
 * so shared components rendered inside a new view still find every palette key they read. Keys
 * that style app builders' content (widget headers and tables, diagram nodes) stay out on purpose.
 */
export const legacyPaletteFromTokens = ({
  bg,
  text,
  action
}: SemanticTokens): Partial<PaletteOptions> => ({
  primaryText: { main: text.primary },
  secondaryText: { main: text.secondary },
  altText: { main: text.secondary },
  notificationTitle: { main: text.secondary },
  whiteBlackContrast: { main: text.primary },
  secondaryBackground: { main: bg.page, dark: bg.muted },
  altBackground: { main: action.ghost.bgHover, dark: action.ghost.bgActive },
  widgetBackground: { main: bg.surface },
  homeMainBox: { main: bg.surface },
  topBar: { main: bg.topbar },
  toggleButtonBg: { main: action.primary.bg },
  disabledAction: { main: action.disabled.text },
  disabledButtonBackground: { main: action.disabled.bg },
  codeWidgetHeader: { main: bg.subtle }
})
